<template>
  <div class="routeGuideDiv" id="routeguide">
    <!-- <van-tabs v-model="active" type="card">
      <van-tab title="红塔厂区平面图" name="1"> -->
    <img
      src="../assets/img/guide2.png"
      alt=""
      class="imgStyle"
      v-if="map_type === 'ht'"
    />
    <!-- </van-tab>
      <van-tab title="华丰厂区平面图" name="2"> -->
    <img
      src="../assets/img/guide1.png"
      alt=""
      class="imgStyle"
      v-if="map_type === 'hf'"
    />
    <!-- </van-tab>
    </van-tabs> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: "1"
    };
  },
  watch: {},
  async mounted() {
    // this.active = this.type === 'ht' ? "1" : "2"
  },
  methods: {},
  created() {},
  computed: {
    map_type() {
      return this.$route.query.map_type;
    }
  }
};
</script>
<style lang="less" scoped>
.routeGuideDiv {
  min-height: calc(100vh - 1px);
  background: #fff;
  border-bottom: 1px solid #f4f5f6;
  .imgStyle {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
<style lang="less">
#routeguide {
  .van-tabs__nav--card .van-tab {
    border: 0px solid #008b5e;
    font-size: 16px;
    border-radius: 4px;
  }
  .van-tabs__nav--card {
    border: 1px solid #008b5e;
    height: 46px;
  }
  .van-tab {
    background: #e7fbf7;
    color: #008b5e;
  }
  .van-tab--active {
    color: #fff;
    background-color: #008b5e;
    border: 0px solid #008b5e;
    margin-top: -1px;
  }
  .van-tabs__nav--card .van-tab {
    border: 0px solid #008b5e;
  }
  .van-tabs--card > .van-tabs__wrap {
    height: 46px;
    padding: 13px 0px;
  }
}
</style>
